/* FansBRANDS Order Support Core V20.3
 * Shared validation + customer-facing order status renderer.
 * Used by both the Help Center and the floating support chat.
 */
(function () {
  'use strict';

  if (window.FansBrandsOrderSupport) return;

  var FIELD_META = {
    order_number: {
      label: 'Numărul comenzii',
      short: 'Numărul comenzii',
      prompt: 'Introdu numărul comenzii',
      hint: 'Îl găsești în e-mailul de confirmare a comenzii. Exemplu: RO12345.',
      placeholder: 'RO12345',
      type: 'text',
      inputMode: 'text',
      autocomplete: 'off',
      maxLength: 40
    },
    email: {
      label: 'Adresă de e-mail',
      short: 'Adresă de e-mail',
      prompt: 'Introdu adresa de e-mail folosită la comandă',
      hint: 'Introdu aceeași adresă de e-mail utilizată la comandă.',
      placeholder: 'exemplu@email.ro',
      type: 'email',
      inputMode: 'email',
      autocomplete: 'email',
      maxLength: 254
    },
    phone: {
      label: 'Număr de telefon',
      short: 'Număr de telefon',
      prompt: 'Introdu numărul de telefon folosit la comandă',
      hint: 'Include prefixul internațional. Exemplu: +40 721 234 567.',
      placeholder: '+40 721 234 567',
      type: 'tel',
      inputMode: 'tel',
      autocomplete: 'tel',
      maxLength: 32
    },
    postal_code: {
      label: 'Cod poștal',
      short: 'Cod poștal',
      prompt: 'Introdu codul poștal al comenzii',
      hint: 'Introdu codul poștal al adresei de livrare sau facturare.',
      placeholder: '010101',
      type: 'text',
      inputMode: 'text',
      autocomplete: 'postal-code',
      maxLength: 16
    }
  };

  function cleanText(value) {
    return String(value || '')
      .replace(/[\u00A0\u2000-\u200D\u202F\u205F\u3000]/g, ' ')
      .trim();
  }

  function normalize(type, value) {
    var raw = cleanText(value);

    if (type === 'order_number') {
      var upper = raw.toUpperCase();
      var embedded = upper.match(/RO[\s#-]*\d{2,}/i);
      if (embedded) return embedded[0].replace(/[\s#-]+/g, '').toUpperCase();
      return upper.replace(/^#+/, '').replace(/\s+/g, '');
    }

    if (type === 'email') {
      return raw.replace(/\s+/g, '').toLowerCase();
    }

    if (type === 'phone') {
      var compact = raw.replace(/[\s().\-\/]/g, '');
      if (!/^[+\d]+$/.test(compact)) return compact;
      if (/^00\d+/.test(compact)) compact = '+' + compact.slice(2);
      if (/^0[237]\d{8}$/.test(compact)) compact = '+40' + compact.slice(1);
      if (/^40\d{9}$/.test(compact)) compact = '+' + compact;
      return compact;
    }

    if (type === 'postal_code') {
      return raw.toUpperCase().replace(/\s+/g, ' ').replace(/\s*-\s*/g, '-');
    }

    return raw;
  }

  function isFansBrandsInternalEmail(email) {
    var normalizedEmail = normalize('email', email);
    var parts = normalizedEmail.split('@');
    if (parts.length !== 2) return false;

    var domain = String(parts[1] || '').toLowerCase().replace(/\.$/, '');
    if (!domain) return false;

    // Tiltjuk a FansBRANDS saját e-mail domainjeit minden piacon,
    // valamint azok aldomainjeit (pl. mail.fansbrands.hu).
    return domain.indexOf('fansbrands.') === 0 || domain.indexOf('.fansbrands.') !== -1;
  }

  function emailTypoSuggestion(email) {
    var parts = email.split('@');
    if (parts.length !== 2) return '';
    var domain = (parts[1] || '').toLowerCase();
    var known = {
      'gamil.com': 'gmail.com', 'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com',
      'gmail.co': 'gmail.com', 'gmail.hu': 'gmail.com', 'hotnail.com': 'hotmail.com',
      'hotmai.com': 'hotmail.com', 'hotmail.co': 'hotmail.com', 'outlok.com': 'outlook.com',
      'outllok.com': 'outlook.com', 'outlook.co': 'outlook.com', 'yaho.com': 'yahoo.com',
      'yahoo.co': 'yahoo.com', 'icloud.co': 'icloud.com'
    };
    return known[domain] || '';
  }

  function validate(type, value) {
    var v = normalize(type, value);

    if (!v) return { error: 'Completează acest câmp.', value: '' };

    if (type === 'order_number') {
      if (v.indexOf('@') !== -1) return { error: 'Pare că ai introdus o adresă de e-mail în locul numărului comenzii.', value: v };
      if (v.length < 3 || v.length > 40 || !/^[A-Z0-9_-]+$/.test(v)) {
        return { error: 'Formatul numărului comenzii nu este corect. Exemplu: RO12345.', value: v };
      }
    }

    if (type === 'email') {
      if (v.length > 254) return { error: 'Adresa de e-mail introdusă este prea lungă.', value: v };
      if ((v.match(/@/g) || []).length !== 1 || !/^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/.test(v)) {
        return { error: 'Formatul adresei de e-mail nu este corect. Exemplu: nume@email.ro.', value: v };
      }
      if (isFansBrandsInternalEmail(v)) {
        return {
          error: 'Folosește adresa personală de e-mail utilizată la comandă, nu o adresă internă FansBRANDS.',
          value: v
        };
      }

      var suggestion = emailTypoSuggestion(v);
      if (suggestion) {
        var local = v.split('@')[0];
        return { error: 'Este posibil să fi scris greșit domeniul e-mailului. Ai vrut să scrii: ' + local + '@' + suggestion + '?', value: v };
      }
    }

    if (type === 'phone') {
      if (/[A-Za-zĂÂÎȘȚăâîșț]/.test(v)) {
        return { error: 'Numărul de telefon nu poate conține litere.', value: v };
      }
      if (!/^\+\d{8,15}$/.test(v)) {
        var digits = String(value || '').replace(/\D/g, '');
        if (/^0[237]\d{8}$/.test(digits)) {
          return { error: 'Lipsește prefixul internațional. Exemplu: +40 721 234 567.', value: v };
        }
        return { error: 'Introdu numărul cu prefix. Exemplu: +40 721 234 567.', value: v };
      }
    }

    if (type === 'postal_code') {
      if (!/^\d{6}$/.test(v)) {
        return { error: 'Formatul codului poștal nu este corect.', value: v };
      }
    }

    return { error: '', value: v };
  }

  function secondaryKeys(primary) {
    if (primary === 'order_number') return ['email', 'phone', 'postal_code'];
    if (primary === 'email') return ['order_number', 'phone', 'postal_code'];
    return [];
  }

  function configureInput(input, type) {
    var meta = FIELD_META[type];
    if (!input || !meta) return;
    input.type = meta.type;
    input.inputMode = meta.inputMode;
    input.autocomplete = meta.autocomplete;
    input.maxLength = meta.maxLength;
    input.placeholder = meta.placeholder;
    input.autocapitalize = type === 'order_number' ? 'characters' : 'none';
    input.spellcheck = false;
    input.value = '';
  }

  function safeUrl(value) {
    if (typeof value !== 'string' || !value) return '';
    try {
      var u = new URL(value);
      return u.protocol === 'https:' && !u.username && !u.password ? u.href : '';
    } catch (_) {
      return '';
    }
  }

  function upper(value) { return String(value || '').toUpperCase(); }

  function bucharestDateParts(value) {
    if (!value) return null;
    var date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return null;
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Bucharest', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(date);
      var out = {};
      parts.forEach(function (p) { if (p.type !== 'literal') out[p.type] = p.value; });
      return { year: Number(out.year), month: Number(out.month), day: Number(out.day) };
    } catch (_) {
      return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
    }
  }

  function ymd(parts) {
    if (!parts) return '';
    return String(parts.year).padStart(4, '0') + '-' + String(parts.month).padStart(2, '0') + '-' + String(parts.day).padStart(2, '0');
  }

  function partsFromYmd(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ''));
    return m ? { year: Number(m[1]), month: Number(m[2]), day: Number(m[3]) } : null;
  }

  function utcDateFromParts(parts) {
    return new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
  }

  function addCalendarDays(parts, days) {
    var d = utcDateFromParts(parts);
    d.setUTCDate(d.getUTCDate() + days);
    return { year: d.getUTCFullYear(), month: d.getUTCMonth() + 1, day: d.getUTCDate() };
  }

  function easterSundayParts(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return { year: year, month: month, day: day };
  }

  // Calendarul zilelor nelucrătoare din România (inclusiv sărbătorile ortodoxe).
  function orthodoxEasterParts(year) {
    var a = year % 4, b = year % 7, c = year % 19;
    var d = (19 * c + 15) % 30;
    var e = (2 * a + 4 * b - d + 34) % 7;
    var month = Math.floor((d + e + 114) / 31);
    var day = ((d + e + 114) % 31) + 1;
    var date = new Date(Date.UTC(year, month - 1, day + 13));
    return { year: date.getUTCFullYear(), month: date.getUTCMonth() + 1, day: date.getUTCDate() };
  }

  function romanianHolidaySet(year) {
    var fixed = [
      year + '-01-01', year + '-01-02', year + '-01-06', year + '-01-07',
      year + '-01-24', year + '-05-01', year + '-06-01', year + '-08-15',
      year + '-11-30', year + '-12-01', year + '-12-25', year + '-12-26'
    ];
    var easter = orthodoxEasterParts(year);
    fixed.push(ymd(addCalendarDays(easter, -2))); // Vinerea Mare
    fixed.push(ymd(addCalendarDays(easter, 1)));  // a doua zi de Paște
    fixed.push(ymd(addCalendarDays(easter, 50))); // a doua zi de Rusalii
    return new Set(fixed);
  }

  function isRomanianWorkday(parts) {
    var day = utcDateFromParts(parts).getUTCDay();
    if (day === 0 || day === 6) return false;
    return !romanianHolidaySet(parts.year).has(ymd(parts));
  }

  function nextRomanianWorkday(parts) {
    var cur = addCalendarDays(parts, 1);
    while (!isRomanianWorkday(cur)) cur = addCalendarDays(cur, 1);
    return cur;
  }

  function addRomanianWorkdays(parts, count) {
    var cur = { year: parts.year, month: parts.month, day: parts.day };
    var added = 0;
    while (added < count) {
      cur = addCalendarDays(cur, 1);
      if (isRomanianWorkday(cur)) added += 1;
    }
    return cur;
  }

  function compareParts(a, b) {
    return utcDateFromParts(a).getTime() - utcDateFromParts(b).getTime();
  }

  function businessDaysInclusive(start, end) {
    if (compareParts(start, end) > 0) return 0;
    var cur = { year: start.year, month: start.month, day: start.day };
    var count = 0;
    while (compareParts(cur, end) <= 0) {
      if (isRomanianWorkday(cur)) count += 1;
      cur = addCalendarDays(cur, 1);
    }
    return count;
  }

  function calendarDaysRemaining(today, deadline) {
    return Math.max(0, Math.ceil((utcDateFromParts(deadline) - utcDateFromParts(today)) / 86400000));
  }

  function pickupModel(data) {
    data = data || {};
    var readySource = data.pickupReadyAt || (upper(data.deliveryStatus) === 'READY_FOR_PICKUP' ? data.deliveryHappenedAt : null);
    var ready = bucharestDateParts(readySource);
    var mode = String(data.pickupRetentionMode || '');
    var days = Number(data.pickupRetentionDays || 0);
    var type = String(data.pickupType || '');
    if (!ready || !mode || !days || (type !== 'parcel_point' && type !== 'locker')) return null;

    var deadline = mode === 'business' ? addRomanianWorkdays(ready, days) : addCalendarDays(ready, days);
    var today = bucharestDateParts(new Date());
    if (!today) return null;

    var expired = compareParts(today, deadline) > 0;
    var remaining;
    var unit;

    if (mode === 'business') {
      var firstCounted = nextRomanianWorkday(ready);
      var start = compareParts(today, firstCounted) < 0 ? firstCounted : today;
      remaining = expired ? 0 : businessDaysInclusive(start, deadline);
      unit = remaining === 1 ? 'zi lucrătoare' : 'zile lucrătoare';
    } else {
      remaining = expired ? 0 : calendarDaysRemaining(today, deadline);
      unit = remaining === 1 ? 'zi' : 'zile';
    }

    return {
      type: type,
      label: data.pickupLabel || (type === 'locker' ? 'Locker' : 'Punct de ridicare'),
      mode: mode,
      days: days,
      readyDate: ymd(ready),
      deadlineDate: ymd(deadline),
      remaining: remaining,
      unit: unit,
      expired: expired,
      urgent: !expired && remaining <= 1
    };
  }

  function statusModel(data) {
    data = data || {};
    var delivery = upper(data.deliveryStatus);
    var fulfillment = upper(data.fulfillmentStatus);
    var carrierName = (data.tracking && data.tracking.company) || data.carrier || '';
    var carrierPage = carrierName ? carrierName + ' pe pagina de urmărire' : 'pagina de urmărire a curierului';

    if (data.cancelled) {
      return {
        key: 'cancelled', tone: 'red', label: 'Comandă anulată',
        message: 'Comanda a fost anulată; nu va fi pregătită sau livrată.',
        problem: true, showTracking: false
      };
    }

    if (delivery === 'ATTEMPTED_DELIVERY') {
      return {
        key: 'attempted_delivery', tone: 'red', label: 'Livrare nereușită',
        message: 'Curierul a încercat să livreze coletul, dar livrarea nu a reușit. Vezi detaliile pe ' + carrierPage + ', sau contactează asistența.',
        problem: true, showTracking: true
      };
    }

    if (delivery === 'FAILURE' || delivery === 'NOT_DELIVERED' || delivery === 'CANCELED') {
      return {
        key: 'delivery_problem', tone: 'red', label: 'Problemă la livrare',
        message: 'Curierul a semnalat o problemă la livrare. Verifică detaliile pe ' + carrierPage + ', sau contactează-ne.',
        problem: true, showTracking: true
      };
    }

    if (delivery === 'DELAYED') {
      return {
        key: 'delayed', tone: 'red', label: 'Colet întârziat',
        message: 'Curierul a semnalat o întârziere. Verifică cele mai recente informații pe ' + carrierPage + ' .',
        problem: true, showTracking: true
      };
    }

    if (delivery === 'DELIVERED') {
      return {
        key: 'delivered', tone: 'green', label: 'Livrat',
        message: 'Potrivit curierului, coletul a fost livrat. Dacă nu l-ai primit, contactează-ne.',
        problem: false, showTracking: true
      };
    }

    if (delivery === 'OUT_FOR_DELIVERY') {
      return {
        key: 'out_for_delivery', tone: 'blue', label: 'În curs de livrare',
        message: 'Coletul este în curs de livrare. IMPORTANT: pe site-ul curierului găsești cele mai recente informații și, dacă este disponibil, intervalul estimat de livrare. Asigură-te că poți primi coletul la adresa indicată.',
        problem: false, showTracking: true
      };
    }

    if (delivery === 'IN_TRANSIT' || delivery === 'CARRIER_PICKED_UP') {
      return {
        key: 'in_transit', tone: 'blue', label: 'În drum spre tine',
        message: 'Coletul a fost preluat de curier. IMPORTANT: verifică site-ul curierului pentru informații actualizate și intervalul estimat de livrare, dacă este disponibil. Dacă livrarea este programată pentru astăzi, asigură-te că poți primi coletul.',
        problem: false, showTracking: true
      };
    }

    if (delivery === 'READY_FOR_PICKUP') {
      var pickup = pickupModel(data);
      if (pickup && pickup.expired) {
        return {
          key: 'pickup_expired', tone: 'red', label: 'Termenul de ridicare a expirat',
          message: 'Termenul de ridicare a expirat; coletul poate fi returnat expeditorului. Verifică pagina curierului sau contactează-ne.',
          problem: true, showTracking: true
        };
      }
      return {
        key: 'ready_for_pickup', tone: 'blue', label: 'Gata de ridicare',
        message: pickup
          ? 'Coletul tău a ajuns la ' + pickup.label + ' pentru ridicare. Ridică-l înainte de termenul-limită.'
          : 'Coletul poate fi ridicat. Găsești detaliile în notificarea curierului.',
        problem: false, showTracking: true
      };
    }

    if (delivery === 'PICKED_UP') {
      return {
        key: 'picked_up', tone: 'green', label: 'Ridicat',
        message: 'Sistemul arată că pachetul a fost ridicat. Dacă nu este corect, contactează-ne.',
        problem: false, showTracking: false
      };
    }

    if (delivery === 'LABEL_VOIDED') {
      return {
        key: 'label_voided', tone: 'yellow', label: 'Pregătirea expedierii',
        message: 'Eticheta de livrare anterioară a fost anulată. Comanda este încă în curs de procesare.',
        problem: false, showTracking: false
      };
    }

    if (fulfillment === 'FULFILLED' || delivery === 'FULFILLED' || delivery === 'MARKED_AS_FULFILLED' || delivery === 'LABEL_PRINTED' || delivery === 'LABEL_PURCHASED' || delivery === 'CONFIRMED' || delivery === 'SUBMITTED') {
      return {
        key: 'packed', tone: 'yellow', label: 'Ambalat',
        message: 'Comanda a fost pregătită. Următorul pas este predarea către curier.',
        problem: false, showTracking: false
      };
    }

    if (fulfillment === 'IN_PROGRESS') {
      return {
        key: 'packing', tone: 'yellow', label: 'În curs de pregătire',
        message: 'Pregătim comanda; momentan nu trebuie să faci nimic.',
        problem: false, showTracking: false
      };
    }

    if (fulfillment === 'PARTIALLY_FULFILLED') {
      return {
        key: 'partially_packed', tone: 'yellow', label: 'Pregătită parțial',
        message: 'O parte din comandă a fost pregătită. Dacă sunt mai multe colete, poți primi notificări separate.',
        problem: false, showTracking: false
      };
    }

    if (fulfillment === 'ON_HOLD') {
      return {
        key: 'on_hold', tone: 'yellow', label: 'În verificare',
        message: 'Comanda este verificată. Dacă starea nu se schimbă, contactează-ne.',
        problem: false, showTracking: false
      };
    }

    if (fulfillment === 'FULFILLMENT_NOT_REQUIRED') {
      return {
        key: 'no_shipping', tone: 'yellow', label: 'Nu necesită expediere',
        message: 'Această comandă nu necesită expedierea unui colet fizic.',
        problem: false, showTracking: false
      };
    }

    return {
      key: 'processing', tone: 'yellow', label: 'În procesare',
      message: 'Am primit comanda și o procesăm. Nu trebuie să faci nimic acum.',
      problem: false, showTracking: false
    };
  }

  function paymentMethodLabel(name) {
    var raw = String(name || '').trim();
    if (!raw) return '';
    if (/^shopify[_\s-]*payments$/i.test(raw)) return 'Card bancar';
    return raw;
  }

  function paymentModel(data) {
    data = data || {};
    var status = upper(data.financialStatus);
    var gateways = Array.isArray(data.paymentGatewayNames) ? data.paymentGatewayNames.filter(Boolean) : [];
    var isCod = data.isCod === true || gateways.some(function (name) {
      return /cash\s*on\s*delivery|\bcod\b|ramburs|plata la livrare|ut[aá]nv[eé]t/i.test(String(name));
    });
    var method = isCod ? 'Ramburs' : paymentMethodLabel(gateways[0]);

    if (isCod && status === 'PENDING') {
      var pickupType = String(data.pickupType || '').toLowerCase();
      var codMessage = pickupType
        ? 'Plătești la ridicare. Verifică metodele de plată disponibile la punctul de ridicare.'
        : 'Plătești la livrare, în numerar sau cu cardul, în funcție de opțiunile curierului.';
      return {
        key: 'cod', label: 'Ramburs', method: 'Ramburs',
        message: codMessage
      };
    }
    if (status === 'PAID') return { key: 'paid', label: 'Fizetve', method: method, message: 'Nu ai alte plăți de efectuat.' };
    if (status === 'AUTHORIZED') return { key: 'authorized', label: 'Plată autorizată', method: method, message: 'Plata este autorizată. Nu trebuie să faci nimic.' };
    if (status === 'PARTIALLY_PAID') return { key: 'partial', label: 'Plătită parțial', method: method, message: 'Doar o parte din valoarea comenzii este achitată.' };
    if (status === 'REFUNDED') return { key: 'refunded', label: 'Rambursată', method: method, message: 'Suma a fost rambursată.' };
    if (status === 'PARTIALLY_REFUNDED') return { key: 'partial_refund', label: 'Rambursată parțial', method: method, message: 'O parte din valoarea comenzii a fost rambursată.' };
    if (status === 'VOIDED') return { key: 'voided', label: 'Anulată', method: method, message: 'Plata a fost anulată.' };
    if (status === 'EXPIRED') return { key: 'expired', label: 'Plata a expirat', method: method, message: 'Plata nu s-a finalizat în timp util. Dacă ai nevoie de ajutor, contactează-ne.' };
    if (status === 'PENDING') return { key: 'pending', label: 'În așteptarea plății', method: method, message: 'Plata nu a fost încă finalizată. Dacă este neașteptat, contactează-ne.' };
    return { key: 'unknown', label: 'Plată', method: method, message: 'Informațiile de plată nu sunt disponibile momentan.' };
  }

  function formatDate(value) {
    if (!value) return '–';
    try {
      return new Intl.DateTimeFormat('ro-RO', { year: 'numeric', month: 'long', day: 'numeric' }).format(new Date(value));
    } catch (_) { return String(value); }
  }

  function formatMoney(money) {
    if (!money || money.amount == null) return '–';
    var currency = money.currencyCode || 'RON';
    try {
      return new Intl.NumberFormat('ro-RO', {
        style: 'currency', currency: currency, maximumFractionDigits: currency === 'RON' ? 2 : 2
      }).format(Number(money.amount));
    } catch (_) {
      return money.amount + ' ' + currency;
    }
  }

  function el(tag, className, text) {
    var n = document.createElement(tag);
    if (className) n.className = className;
    if (text != null) n.textContent = text;
    return n;
  }

  function whatsappUrl(baseUrl, data, status) {
    var safe = safeUrl(baseUrl);
    if (!safe) return '';
    try {
      var u = new URL(safe);
      var message = 'Bună! Am nevoie de ajutor cu comanda';
      if (data && data.name) message += ' ' + data.name;
      if (status && status.label) message += '. Stare: ' + status.label;
      message += '.';
      u.searchParams.set('text', message);
      return u.href;
    } catch (_) { return safe; }
  }

  function appendWhatsApp(container, baseUrl, data, status, strong) {
    var href = whatsappUrl(baseUrl, data, status);
    if (!href) return;
    var a = el('a', strong ? 'fb-order-whatsapp is-strong' : 'fb-order-whatsapp', strong ? 'CONTACTEAZĂ ASISTENȚA' : 'Ai întrebări? Contactează-ne');
    a.href = href;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    container.appendChild(a);
  }

  function formatDateOnly(value) {
    var p = partsFromYmd(value);
    if (!p) return 'Nu există încă date';
    try {
      return new Intl.DateTimeFormat('ro-RO', {
        year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC'
      }).format(utcDateFromParts(p));
    } catch (_) { return value; }
  }

  function appendPickupCountdown(container, data, status, options) {
    if (upper(data.deliveryStatus) !== 'READY_FOR_PICKUP') return;
    var pickup = pickupModel(data);
    if (!pickup) return;

    var box = el('div', 'fb-order-view__pickup' + (pickup.expired ? ' is-expired' : (pickup.urgent ? ' is-urgent' : '')));
    var top = el('div', 'fb-order-view__pickup-top');
    var copy = el('div');
    copy.appendChild(el('span', '', pickup.label === 'GLS Automata' ? 'TERMEN DE RIDICARE – GLS LOCKER' : 'TERMEN DE RIDICARE – PUNCT GLS'));
    copy.appendChild(el('strong', '', pickup.expired ? 'Termenul de ridicare a expirat' : ('Mai sunt ' + pickup.remaining + ' ' + pickup.unit + ' pentru ridicare')));
    top.appendChild(copy);
    box.appendChild(top);

    var dates = el('div', 'fb-order-view__pickup-dates');
    var arrived = el('div');
    arrived.appendChild(el('span', '', 'Sosit la punctul de ridicare'));
    arrived.appendChild(el('strong', '', formatDateOnly(pickup.readyDate)));
    var deadline = el('div');
    deadline.appendChild(el('span', '', 'Termen de ridicare'));
    deadline.appendChild(el('strong', '', formatDateOnly(pickup.deadlineDate)));
    dates.append(arrived, deadline);
    box.appendChild(dates);

    var noteWrap = el('div', 'fb-order-view__pickup-note');
    noteWrap.appendChild(el('p', '', pickup.mode === 'business'
      ? 'La punctul GLS, termenul de ridicare este de 5 zile lucrătoare (verifică notificarea curierului).'
      : 'La lockerul GLS, termenul de păstrare este de 7 zile calendaristice (verifică notificarea curierului).'));
    var important = el('p', 'fb-order-view__pickup-important');
    important.appendChild(el('strong', 'fb-order-important', 'IMPORTANT:'));
    important.appendChild(document.createTextNode(' Termenul comunicat de GLS este cel aplicabil.'));
    noteWrap.appendChild(important);
    box.appendChild(noteWrap);

    container.appendChild(box);
  }

  function appendStatusMessage(container, status, data) {
    var box = el('div', 'fb-order-view__message fb-order-view__message--structured');

    function addParagraph(text, className) {
      if (!text) return;
      box.appendChild(el('p', className || '', text));
    }

    function addImportant(text) {
      var p = el('p', 'fb-order-view__important-line');
      p.appendChild(el('strong', 'fb-order-important', 'IMPORTANT:'));
      p.appendChild(document.createTextNode(' ' + text));
      box.appendChild(p);
    }

    if (status.key === 'in_transit') {
      addParagraph('Coletul a fost preluat de curier.', 'fb-order-view__message-title');
      addImportant('Pe site-ul curierului găsești ultimele actualizări și, dacă este disponibil, intervalul estimat de livrare.');
      addParagraph('Dacă livrarea este programată pentru astăzi, asigură-te că poți primi coletul.');
    } else if (status.key === 'out_for_delivery') {
      addParagraph('Coletul este în curs de livrare.', 'fb-order-view__message-title');
      addImportant('Verifică ora sau intervalul estimat pe site-ul curierului.');
      addParagraph('Asigură-te că poți primi coletul la adresa indicată.');
    } else if (status.key === 'ready_for_pickup') {
      addParagraph('Coletul este disponibil pentru ridicare.', 'fb-order-view__message-title');
      addImportant('Ridică coletul înainte de termenul indicat în notificarea curierului.');
    } else if (status.key === 'pickup_expired') {
      addParagraph('Termenul de ridicare a expirat.', 'fb-order-view__message-title');
      addImportant('Este posibil ca pachetul să fie returnat expeditorului.');
      addParagraph('Verifică pagina curierului sau contactează asistența.');
    } else if (status.key === 'attempted_delivery' || status.key === 'delivery_problem' || status.key === 'delayed') {
      addParagraph(status.message, 'fb-order-view__message-title');
      addImportant('Verifică urmărirea coletului pe site-ul curierului; contactează-ne dacă ai nevoie de ajutor.');
    } else {
      addParagraph(status.message);
    }

    container.appendChild(box);
  }

  function renderOrder(container, data, options) {
    options = options || {};
    if (!container) return;
    var status = statusModel(data);
    var payment = paymentModel(data);
    var tracking = data && data.tracking ? data.tracking : {};
    var trackingUrl = safeUrl(tracking.url);
    var carrier = tracking.company || data.carrier || '';

    container.replaceChildren();
    container.classList.add('fb-order-view');

    var head = el('div', 'fb-order-view__head');
    var id = el('div', 'fb-order-view__identity');
    id.appendChild(el('span', 'fb-order-view__eyebrow', 'COMANDĂ'));
    id.appendChild(el('strong', 'fb-order-view__name', data.name || 'Comandă'));
    head.appendChild(id);
    head.appendChild(el('span', 'fb-order-badge is-' + status.tone, status.label));
    container.appendChild(head);

    appendStatusMessage(container, status, data);

    if (data.cancelled) {
      appendWhatsApp(container, options.whatsappUrl, data, status, true);
      container.hidden = false;
      return;
    }

    var meta = el('div', 'fb-order-view__meta');
    var dateBox = el('div', 'fb-order-view__meta-item');
    dateBox.appendChild(el('span', '', 'Data comenzii'));
    dateBox.appendChild(el('strong', '', formatDate(data.processedAt || data.createdAt)));
    var totalBox = el('div', 'fb-order-view__meta-item');
    totalBox.appendChild(el('span', '', 'Valoarea comenzii'));
    totalBox.appendChild(el('strong', '', formatMoney(data.total)));
    meta.append(dateBox, totalBox);

    var pickup = pickupModel(data);
    var pickupReadySource = data.pickupReadyAt || (upper(data.deliveryStatus) === 'READY_FOR_PICKUP' ? data.deliveryHappenedAt : null);
    var isReadyPickup = upper(data.deliveryStatus) === 'READY_FOR_PICKUP' && !!pickupReadySource;
    var isDelivered = status.key === 'delivered' || upper(data.deliveryStatus) === 'DELIVERED';
    var deliveredSource = data.deliveredAt || (isDelivered ? data.deliveryHappenedAt : null);

    var expectedLabel = '';
    var expectedValue = '';

    // Csak ténylegesen rendelkezésre álló dátumot mutatunk.
    // A Shopify a GLS várható kézbesítési idejét nem feltétlenül adja át.
    if (isDelivered && bucharestDateParts(deliveredSource)) {
      expectedLabel = 'Expediată';
      expectedValue = formatDate(deliveredSource);
    } else if (isReadyPickup && bucharestDateParts(pickupReadySource)) {
      expectedLabel = 'Sosit la punctul de ridicare';
      expectedValue = formatDate(pickupReadySource);
    } else if (!isDelivered && !isReadyPickup && bucharestDateParts(data.estimatedDeliveryAt)) {
      expectedLabel = data.pickupType ? 'Sosire estimată la punctul de ridicare' : 'Livrare estimată';
      expectedValue = formatDate(data.estimatedDeliveryAt);
    }

    if (expectedLabel && expectedValue) {
      var expectedBox = el('div', 'fb-order-view__meta-item fb-order-view__meta-item--expected');
      expectedBox.appendChild(el('span', '', expectedLabel));
      expectedBox.appendChild(el('strong', '', expectedValue));
      meta.appendChild(expectedBox);
    }
    container.appendChild(meta);

    var pay = el('div', 'fb-order-view__payment');
    var payTop = el('div', 'fb-order-view__payment-top');
    payTop.appendChild(el('span', '', 'Plată'));
    payTop.appendChild(el('strong', '', payment.label));
    pay.appendChild(payTop);
    if (payment.method && payment.method !== payment.label) pay.appendChild(el('small', '', 'Metodă de plată: ' + payment.method));
    pay.appendChild(el('p', '', payment.message));
    container.appendChild(pay);

    appendPickupCountdown(container, data, status, options);

    var hasTracking = !!(tracking.number || trackingUrl || carrier);
    if (hasTracking || status.showTracking) {
      var ship = el('div', 'fb-order-view__shipping');
      if (carrier) {
        var carrierBox = el('div');
        carrierBox.appendChild(el('span', '', 'Curier'));
        carrierBox.appendChild(el('strong', '', carrier));
        ship.appendChild(carrierBox);
      }
      if (tracking.number) {
        var trackBox = el('div');
        trackBox.appendChild(el('span', '', 'Număr de urmărire'));
        trackBox.appendChild(el('strong', '', tracking.number));
        ship.appendChild(trackBox);
      }
      if (trackingUrl) {
        var isGls = /gls/i.test(String(carrier || ''));
        if (status.key === 'in_transit' || status.key === 'out_for_delivery') {
          var actionBox = el('div');
          actionBox.style.gridColumn = '1 / -1';
          actionBox.appendChild(el('span', '', 'Informații despre livrare'));
          actionBox.appendChild(el('strong', '', isGls
            ? 'Pe site-ul GLS găsești informații actualizate și intervalul estimat de livrare (dacă este disponibil). Poate fi necesar codul poștal.'
            : 'Pe site-ul curierului găsești informații actualizate și intervalul estimat de livrare (dacă este disponibil). Poate fi necesar codul poștal.'));
          ship.appendChild(actionBox);
        }
        var buttonLabel = isGls ? 'DESCHIDE URMĂRIREA GLS'
          : (carrier ? carrier.toUpperCase() + ' DESCHIDE URMĂRIREA' : 'URMĂREȘTE COLETUL');
        var button = el('a', 'fb-order-track-button', buttonLabel);
        button.href = trackingUrl;
        button.target = '_blank';
        button.rel = 'noopener noreferrer';
        // A nyomkövetési gomb a futáradatok elé kerül, hogy könnyen megtalálható legyen.
        ship.prepend(button);
      }
      // A futár oldalára vezető hivatkozás az első imaginiernyőn is könnyebben elérhető.
      container.insertBefore(ship, meta);
    }

    appendWhatsApp(container, options.whatsappUrl, data, status, status.problem || status.key === 'delivered');
    container.hidden = false;
  }

  function noMatchMessage(secondType) {
    var labels = {
      email: 'adresa de e-mail', phone: 'numărul de telefon', postal_code: 'codul poștal', order_number: 'numărul comenzii'
    };
    var label = labels[secondType] || 'a doua informație';
    return 'Cele două informații nu corespund niciunei comenzi. Verifică în special ' + label + '. Din motive de securitate, nu indicăm care dintre date este incorectă.';
  }

  window.FansBrandsOrderSupport = {
    version: '20.3.0',
    fieldMeta: FIELD_META,
    normalize: normalize,
    validate: validate,
    secondaryKeys: secondaryKeys,
    configureInput: configureInput,
    safeUrl: safeUrl,
    statusModel: statusModel,
    paymentModel: paymentModel,
    pickupModel: pickupModel,
    renderOrder: renderOrder,
    noMatchMessage: noMatchMessage
  };
})();
